class AveyManufacturingProcess extends HTMLElement {
  connectedCallback() {
    if (this.isConnectedToMotion) return;

    this.isConnectedToMotion = true;
    this.steps = Array.from(this.querySelectorAll('[data-avey-manufacturing-step]'));
    this.detailSummaries = Array.from(this.querySelectorAll('.avey-manufacturing__details summary'));
    this.handleDetailClick = (event) => {
      const summary = event.currentTarget;
      const topBeforeToggle = summary.getBoundingClientRect().top;

      requestAnimationFrame(() => {
        if (!this.isConnected) return;

        const offset = summary.getBoundingClientRect().top - topBeforeToggle;
        if (Math.abs(offset) > 0.5) window.scrollBy(0, offset);
      });
    };

    this.detailSummaries.forEach((summary) => {
      summary.addEventListener('click', this.handleDetailClick);
    });

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion) this.classList.add('is-reveal-ready');

    if (
      prefersReducedMotion ||
      !('IntersectionObserver' in window)
    ) {
      this.steps.forEach((step) => step.classList.add('is-visible', 'is-revealed'));
      return;
    }

    this.motionObserver = new IntersectionObserver(
      (entries) => {
        let furthestRevealedIndex = -1;

        entries.forEach((entry) => {
          const stepIndex = this.steps.indexOf(entry.target);
          const hasPassedViewport =
            entry.rootBounds && entry.boundingClientRect.bottom < entry.rootBounds.top;

          if (entry.isIntersecting || hasPassedViewport) {
            furthestRevealedIndex = Math.max(furthestRevealedIndex, stepIndex);
          }

          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });

        if (furthestRevealedIndex >= 0) {
          this.steps.slice(0, furthestRevealedIndex + 1).forEach((step) => {
            step.classList.add('is-revealed');
          });
        }
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.3,
      }
    );

    this.steps.forEach((step) => this.motionObserver.observe(step));
  }

  disconnectedCallback() {
    this.motionObserver?.disconnect();
    this.detailSummaries?.forEach((summary) => {
      summary.removeEventListener('click', this.handleDetailClick);
    });
    this.motionObserver = null;
    this.detailSummaries = null;
    this.handleDetailClick = null;
    this.isConnectedToMotion = false;
    this.classList.remove('is-reveal-ready');
  }
}

if (!customElements.get('avey-manufacturing-process')) {
  customElements.define('avey-manufacturing-process', AveyManufacturingProcess);
}
